import { cn } from "@/lib/utils";

/** Hairline rule. 1px, soft. */
export function Rule({
  className,
  vertical = false,
  accent = false,
}: {
  className?: string;
  vertical?: boolean;
  accent?: boolean;
}) {
  return (
    <div
      role="separator"
      aria-orientation={vertical ? "vertical" : "horizontal"}
      className={cn(
        vertical ? "h-full w-px" : "h-px w-full",
        accent ? "bg-accent" : "bg-hair",
        className,
      )}
    />
  );
}
